<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-text-field
          type="text"
          outlined
          label="Nama Perusahaan"
          v-model="perusahaan"        
          readonly     
        />             
        <v-textarea
          outlined
          label="Alamat Perusahaan"    
          v-model="alamat"
          height="142"
          readonly
        ></v-textarea>
        <v-text-field
          type="text"
          outlined
          label="Kode Pos"
          v-model="kodepos"
          readonly
        />  
        <v-text-field
          type="text"
          outlined
          label="Provinsi"
          v-model="provinsi"
          readonly
        /> 
        <v-text-field
          type="text"
          outlined
          label="Kabupaten / Kota"
          v-model="kabKota"
          readonly
        /> 
        <v-text-field
          type="text"
          outlined
          label="Telepon"
          v-model="telepon"
          readonly
        />               
        <v-text-field
          type="text"
          outlined
          label="Fax"
          v-model="fax"
          readonly
        />          
        <v-text-field
          type="text"
          outlined
          label="E-Mail"
          v-model="email"
          readonly
        />      
        <v-text-field
          type="text"
          outlined
          label="Website"
          v-model="website"
          readonly
        />                              
      </v-col>
      <v-col cols="6">    
        <v-text-field
          type="text"
          outlined
          label="Bentuk Usaha"
          :value="bentukCap(bentukUsaha)"
          readonly
        />   
        <v-text-field
          type="text"
          outlined
          label="No. NPWP"
          v-model="npwp"
          readonly
        />                      
        <v-text-field
          type="text"
          outlined
          label="No. Pengukuhan PKP"
          v-model="pengNpkp"
          readonly
        />  

        <!--
        <v-text-field
          type="text"
          outlined
          label="No. PKP"
          v-model="pkp"
          readonly
        />  
        -->

        <v-text-field
          type="text"
          outlined
          label="SK No. PKP"
          v-model="skPkp"
          readonly
          append-icon="get_app"
          @click:append="getLinkDownload(skPkp)"
        />  
        <v-checkbox v-model="cabang" label="Kantor Cabang ?" readonly></v-checkbox>
        <v-textarea
          outlined
          label="Alamat Kantor Pusat"    
          append-icon="check_circle"       
          v-model="alamatPusat"
          height="142"
          readonly
        ></v-textarea>
        <v-text-field
          type="text"
          outlined
          label="Telepon Kantor Pusat"
          v-model="teleponPusat"
          readonly
        />               
        <v-text-field
          type="text"
          outlined
          label="Fax Kantor Pusat"
          v-model="faxPusat"
          readonly
        />          
        <v-text-field
          type="text"
          outlined
          label="E-Mail Kantor Pusat"
          v-model="emailPusat"
          readonly
        />
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <v-text-field
          type="text"
          outlined
          label="Formulir Keikutsertaan"
          v-model="fileFormulir"
          readonly
          append-icon="get_app"
          @click:append="getLinkDownload(fileFormulir)"
        />  
      </v-col>
      <v-col>
        <v-text-field
          type="text"
          outlined
          label="Surat Pernyataan Non PKP"
          v-model="fileNonPKP"
          readonly
          append-icon="get_app"
          @click:append="getLinkDownload(fileNonPKP)"
        />  
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <template v-if="isVerifikasi">
          <v-chip dark color="green">
            <v-avatar left>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-avatar>Sudah Verifikasi
          </v-chip>
        </template>
        <template v-else>
          <v-card>
            <v-textarea v-model="remark" label="Remark: Catatan kekurangan kelengkapan data" outlined ></v-textarea>
            <v-card-actions>
              <v-btn color="success" @click="verifikasiClick()">Verifikasi</v-btn>
              <v-btn color="error" @click="dataKurangLengkapClick()">Data Kurang Lengkap</v-btn>
              <v-label v-if="remarkSubmitted"><span class="blue--text">Catatan kekurangan kelengkapan data diperbarui</span></v-label>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { itemsBentukUsaha } from './../../lib/viewLib'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  name: 'VerifikasiPerusahaan',
  props: [
    'Id'
  ],
  watch: {
    Id: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.getVendorData(newVal)
    }
  },
  data: function() {
    return {
      perusahaan: '',
      alamat: '',
      kodepos: '',    
      npwp: '',
      pengNpkp: '',
      pkp: '',
      skPkp: '',
      email: '',
      website: '',   
      telepon: '',
      fax: '',      
      cabang: false,
      provinsi: '',
      kabKota: '',
      bentukUsaha: '',
      // kantor pusat
      alamatPusat: '',
      teleponPusat: '',
      faxPusat: '',
      emailPusat: '',
      remark: '',
      remarkSubmitted: false,
      fileFormulir: "",
      fileNonPKP: "",

      submitting: false,
    }
  },
  computed: {
    isVerifikasi: function() {
      return this.$store.getters['reg/statusPerusahaan'] === 'A'
    }
  },
  mounted: function() {
    this.getVendorData()
  },
  methods: {
    bentukCap: function(bentuk) { 
      if (bentuk == null || bentuk === '') return "";
      const bentukObj = itemsBentukUsaha.find(el => el.value === bentuk);
      console.log("BentukObj: ", bentukObj);
      return bentukObj.text;
    },
    verifikasiClick: async function() {
      this.submitting = true;

      await axios.post(apiUrl+'/vendor/perusahaan/status', { jenisStatus: 'perusahaan', vendorId: this.$store.getters['ven/venId'], val: 'A'})
      .then((response) => {
        console.log(response)
        this.$store.commit('reg/setStatusPerusahaan', 'A')
      })
      .finally( () => {
        this.submitting = false;
      })
    },
    dataKurangLengkapClick: async function() {
      const payload = {
        jenisStatus: "perusahaan",
        value: this.remark
      };

      this.submitting = true;

      await axios.put(apiUrl + "/vendor/perusahaan/remark/" + this.Id, payload)
      .then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.error(error);
      })
      .finally( () => {
        this.submitting = false;
      });

      this.remarkSubmitted = true;
    },
    getVendorData: async function() {
      this.remarkSubmitted = false;
      
      await axios.get(`${apiUrl}/vendor/registrasi/perusahaan/${this.Id}`)
      .then((response) => {
        const ven = response.data.data
        this.perusahaan = ven.nama
        this.alamat = ven.alamat
        this.kodepos = ven.kodepos    
        this.npwp = ven.npwp
        this.pengNpkp = ven.noPengukuhan
        this.pkp = ven.pkp
        this.skPkp = ven.skPkp
        this.email = ven.email
        this.website = ven.website 
        this.telepon = ven.telepon
        this.fax = ven.fax     
        this.cabang = ven.cabang
        this.provinsi = ven.provinsi
        this.kabKota = ven.kabkod
        this.bentukUsaha = ven.bentuk
        this.fileFormulir = ven.fileFormulir;
        this.fileNonPKP = ven.fileNonPKP;
        this.remark = ven.remarkPerusahaan;

        // kantor pusat
        if (ven.cabang) {
          const pusat = JSON.parse(ven.pusat)
          this.alamatPusat = pusat.alamatPusat
          this.teleponPusat = pusat.teleponPusat
          this.faxPusat = pusat.faxPusat
          this.emailPusat = pusat.emailPusat
        }
        else {
          this.alamatPusat = ''
          this.teleponPusat = ''
          this.faxPusat = ''
          this.emailPusat = ''
        }

        //console.log("response: ", response.data.data);
      })
    },

    getLinkDownload: function(dok) {
      /*
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
      */
      window.open(`${apiUrl}/${dok}`, '_blank');
    },

  }
}
</script>

<style>

</style>